import Mute from '@/javascripts/components/Mute';
import { highlightElementsInContainers } from '@/utils/highlighter';

function highlightKeywords() {
  highlightElementsInContainers(
    '.js-highlight-container',
    '.js-highlight',
    (container: Element) => {
      const keywordsStr = (container as HTMLElement).dataset.highlightKeyword;
      if (!keywordsStr) return [];
      return keywordsStr.split(' ').filter(k => k.trim().length > 0);
    }
  );
}

document.addEventListener('DOMContentLoaded', () => {
  new Mute().addToggleMuteEvent();
  highlightKeywords();
});
